import Reveal from '@/components/base/Reveal';

const HIGHLIGHTS = [
  {
    icon: 'ri-search-eye-line',
    title: 'Personally Sourced',
    body: 'Every request is read and considered by Daniella herself.',
  },
  {
    icon: 'ri-anchor-line',
    title: 'Thoughtfully Matched',
    body: 'Introductions reflect your vision, needs and budget.',
  },
  {
    icon: 'ri-links-line',
    title: 'Independently Arranged',
    body: 'You contract, book and pay suppliers directly.',
  },
];

export default function DifferenceSection() {
  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-16 md:py-28 bg-background-950">
      <div className="max-w-content mx-auto">
        <Reveal className="max-w-3xl">
          <span className="font-label text-xs uppercase tracking-widest2 text-secondary-700">
            The Difference
          </span>
          <h2 className="mt-4 font-heading text-2xl md:text-4xl leading-tight text-background-50">
            Independent connections. Personal attention.
          </h2>
          <p className="mt-5 text-base leading-relaxed text-background-300 max-w-2xl">
            We&rsquo;re not an event planning agency or an automated supplier directory. KOR38 is a
            personal introduction service, built around listening, understanding and connecting you
            with the right people.
          </p>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
          {HIGHLIGHTS.map((item, index) => (
            <Reveal key={item.title} delay={index * 90} className="rounded-lg bg-background-900 border border-background-800 p-6 md:p-7">
              <span className="w-12 h-12 rounded-md bg-secondary-900 flex items-center justify-center">
                <i className={`${item.icon} text-2xl text-primary-400`} aria-hidden="true"></i>
              </span>
              <h3 className="mt-5 font-heading text-lg md:text-xl text-background-50">{item.title}</h3>
              <p className="mt-3 text-base leading-relaxed text-background-300">{item.body}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}